import { render } from "./settings-networks.vue?vue&type=template&id=1ef85652"
import script from "./settings-networks.vue?vue&type=script&lang=js"
export * from "./settings-networks.vue?vue&type=script&lang=js"

import "./settings-networks.vue?vue&type=style&index=0&id=1ef85652&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__